<template>
  <Card :title="$t('global.control-panel')">
    <ErrorState v-if="status.isErrored" />
    <LoadingState v-else-if="status.isLoading || status.isUninitialized" />
    <CardActionContent
      v-else-if="status.isLoaded"
      :description="$t('global.control-panel-description')"
      :buttons="[controlPanelButton]"
    />
  </Card>
</template>

<script>
import Card from "@/components/display/Card";
import CardActionContent from "@/components/display/card-sub-components/CardActionContent";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import NavLink from "@/classes/NavLink";
import Status from "@/classes/Status";

export default {
  name: "ControlPanel",
  components: {
    Card,
    CardActionContent,
    ErrorState,
    LoadingState,
  },
  props: {
    url: String,
    status: Status,
  },
  setup(props, { root }) {
    // open new tab for control panel
    const launchControlPanel = () => {
      window.open(props.url, "_blank");
    };

    // control panel card's action buttons
    const controlPanelButton = new NavLink(
      root.$t("global.launch-control-panel"),
      null,
      launchControlPanel,
      false,
      "primary"
    );

    return {
      controlPanelButton,
    };
  },
};
</script>
